import { router } from "/src/v2/app/providers";
import modalHolder from "@/helpers/modalHolder";
import userApi from "@/api/user";
import { setLocale } from "@v2/shared/config";

const state = {
  isLoggedIn: false,
  user: {},
  token: localStorage.getItem("user-token") || ""
};

const mutations = {
  LOGIN(state, { data, token }) {
    state.isLoggedIn = true;
    state.user = data;
    state.token = token;
    if (data.locale) setLocale(data.locale);
    localStorage.setItem("user-token", token);
  },

  UPDATE_TOKEN(state, token) {
    state.token = token;
    localStorage.setItem("user-token", token);
  },

  SET_USER(state, user) {
    state.user = Object.assign(state.user, user);
    state.isLoggedIn = true;
  },

  LOGOUT(state) {
    state.isLoggedIn = false;
    state.user = {};
    localStorage.removeItem("user-token");
    state.token = "";
    state.userId = null;
  }
};

const actions = {
  logout({ commit }) {
    modalHolder.clear();

    commit("LOGOUT");

    router.push({
      name: "login"
    });
  },

  async getUser({ commit }) {
    const userResponse = await userApi.get();

    if (userResponse && userResponse.data) {
      commit("SET_USER", userResponse.data);
    }
  },

  setUser({ commit }, user) {
    commit("SET_USER", user);
  },

  updateToken({ commit }, token) {
    commit("UPDATE_TOKEN", token);
  }
};

const getters = {
  userId: state => state.user?.id || null,
  isAuthenticated: state => !!state.token,
  token: state => state.token,
  user: state => (state.user ? state.user : {})
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
